import { useLocation } from 'react-router-dom';

const useQuery = (paramName) => {
  const params = new URLSearchParams(useLocation().search);
  const queryParam = params.get(paramName);
  return queryParam;
};

export default useQuery;
